// async function removeFromCart(id) {
//   console.log("function: removeFromCart", id);
//   try {
//     const cart = await $.getJSON("/cart.js");
//     const removedItem = cart.items.find((item) => item.key === id);
//     console.log(removedItem);
//     if (removedItem) {
//       const removedProductName = removedItem.title.toLowerCase();
//       //const removingItem = removedItem.key;

//       // Check if the _bundle-identity property exists
//       const removedProductBundleIdentity =
//         removedItem.properties && removedItem.properties["_bundle-identity"];
//       console.log(removedProductBundleIdentity);
//       await $.ajax({
//         method: "POST",
//         url: "/cart/change.js",
//         data: {
//           id: removingItem,
//           quantity: 0,
//         },
//         dataType: "json",
//         success: async () => {
//           console.log("Item removed successfully!");
//           await removeItemsWithSamePropertyName(removedProductBundleIdentity);
//         },
//         error: (error) => {
//           console.error("Error removing item:", error);
//         },
//       });
//     } else {
//       console.error("Error: Item not found in the cart.");
//     }
//   } catch (error) {
//     console.error("Error removing item:", error);
//   }
// }

async function removeFromCart(id) {
  console.log("function: removeFromCart", id);
  try {
    const cart = await $.getJSON("/cart.js");
    const removedItem = cart.items.find((item) => item.key === id);
    console.log(removedItem);
    if (removedItem) {
      const removedProductName = removedItem.title.toLowerCase();
      await $.ajax({
        method: "POST",
        url: "/cart/change.js",
        data: {
          id: id, // Corrected variable name
          quantity: 0,
        },
        dataType: "json",
        success: async () => {
          console.log("Item removed successfully!");
          const removedProductBundleIdentity =
            removedItem.properties &&
            removedItem.properties["_bundle-identity"];
          await removeItemsWithSamePropertyName(removedProductBundleIdentity);
        },
        error: (error) => {
          console.error("Error removing item:", error);
        },
      });
    } else {
      console.error("Error: Item not found in the cart.");
    }
  } catch (error) {
    console.error("Error removing item:", error);
  }
}

async function removeItemsWithSamePropertyName(removedProductBundleIdentity) {
  console.log(
    "Function removeItemsWithSamePropertyName:",
    removedProductBundleIdentity
  );
  try {
    document.querySelectorAll("#mini-cart-form .line-item").forEach((item) => {
      item.querySelector(".line-item__loader").removeAttribute("hidden");
      item
        .querySelector(".line-item__loader-spinner")
        .removeAttribute("hidden");
      setTimeout(function () {
        item.querySelector(".line-item__loader").setAttribute("hidden", "true");
        item
          .querySelector(".line-item__loader-spinner")
          .setAttribute("hidden", "true");
      }, 3000);
    });
    const cart = await $.getJSON("/cart.js");
    const productItemArray = cart.items;
    let updates = {};
    let matchingProductsFound = false;
    console.log(productItemArray);
    for (const item of productItemArray) {
      if (
        removedProductBundleIdentity &&
        item.properties &&
        item.properties["_bundle-identity"] === removedProductBundleIdentity
      ) {
        updates[item.key] = 0;
        matchingProductsFound = true;
      }
    }

    if (matchingProductsFound) {
      await updateCartItems(updates);
    } else {
      console.log("No matching products found. Refreshing the cart.");
      refreshCart();
      setTimeout(function () {
        console.log("Refreshing the cart.");
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
        updateCartCount();
      }, 700);
    }
  } catch (error) {
    console.error("Error removing items with the same property name:", error);
  }
}

async function updateCartItems(updates) {
  try {
    await $.ajax({
      method: "POST",
      url: "/cart/update.js",
      data: {
        updates: updates,
      },
      dataType: "json",
      success: () => {
        console.log("Cart updated successfully:");
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
        document
          .querySelectorAll("#mini-cart-form .line-item")
          .forEach((item) => {
            item.querySelector(".line-item__loader").removeAttribute("hidden");
            item
              .querySelector(".line-item__loader-spinner")
              .removeAttribute("hidden");
            setTimeout(function () {
              item
                .querySelector(".line-item__loader")
                .setAttribute("hidden", "true");
              item
                .querySelector(".line-item__loader-spinner")
                .setAttribute("hidden", "true");
            }, 3000);
          });
        updateCartCount();
      },
      error: (error) => {
        console.error("Error updating cart:", error);
      },
    });
  } catch (error) {
    console.error("Error updating cart:", error);
  }
}

function refreshCart() {
  setTimeout(function () {
    console.log("Refreshing the cart.");
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );
    updateCartCount();
  }, 500);
}

async function remove_From_Cart() {
  try {
    const cartData = await $.getJSON("/cart.js");
    console.log("Cart Data:", cartData);
  } catch (error) {
    console.error("Error retrieving cart data:", error);
  }
}

// Call the function
remove_From_Cart();

